// extracted by mini-css-extract-plugin
export default {"tile":"tile_tile__JGpVv","tileImg":"tile_tileImg__TmME5","tileTitle":"tile_tileTitle__O9PF3","tileSubTitle":"tile_tileSubTitle__wWW5X","tile_Success":"tile_tile_Success__9lzzA"};